import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base/base-step.component';
import { EnderecoTipo, TelefoneTipo } from '../../../entity/enumeraveis';
import { FormGroup } from '@angular/forms';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'gerenciamento-capacitadora-etapa1',
    templateUrl: './gerenciamento-capacitadora-etapa1.component.html',
})
export class CrudGerenciamentoCapacitadoraEtapa1Component extends BaseStepComponent {
    cpf: any;
    telefoneTipo = TelefoneTipo;
    enderecoTipo = EnderecoTipo;
    @Input() codigo: string;
    @Input() dataCadastro: Date;
    @Input() dataEnvio: Date;
    @Input() classificacaoOptions: SelectItem[] = [];
    @Input() ufOptions: any[] = [];
    @Input() listaResumo: any[] = [];
    @Input() listaRelatores: any[];
    @Input() listaTipoEndereco: SelectItem[];
    @Input() listaTipoLogradouro: SelectItem[];
    @Input() listaCidade: SelectItem[];
    @Input() listaTipoTelefone: any[] = [];

    @Input() listaEndereco: any[] = [];
    @Output() listaEnderecoChange = new EventEmitter<any[]>();

    @Input() listaEmail: any[] = [];
    @Output() listaEmailChange = new EventEmitter<any[]>();

    @Input() listaTelefone: any[] = [];
    @Output() listaTelefoneChange = new EventEmitter<any[]>();

    @Input() listaResponsaveis: any[] = [];
    @Output() listaResponsaveisChange = new EventEmitter<any[]>();

    @Input() uploadedFiles: any[];
    @Input() storagedListFiles: any[];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    @Output() controladorFilialChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    @Input() validateForm: any = false;
    @Input() isBuscou: boolean;
    @Input() controladorFilial: boolean;
    @Input() controladorRegistro: boolean;
    @Output() validateFormChange = new EventEmitter<any>();
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    @Output() buscaRegistro = new EventEmitter<any>();
    @Output() limparRegistro = new EventEmitter<any>();
    @Input() listaCidadeFiltro: SelectItem[] = [];
    @Input() isValidBairro = false;
    @Input() isValidCidade = true;

    @Input() disableButton = true;

    @Input() flg_principal = false;

    @Input() recurso: RecursoFiltro;

    buscaBack(event: any) {
        this.buscaRegistro.emit(event);
    }
    limpar(event: any) {
        this.limparRegistro.emit(event);
    }

    init() {
        // Empresa
        this.cadastro.get('capacitadora.nome').disable();
        this.cadastro.get('capacitadora.id_classificacao').disable();
        this.cadastro.get('capacitadora.url').disable();
        this.cadastro.get('capacitadora.observacao').disable();

        // Endereço
        this.cadastro.get('endereco_capacitadora.num_cep').disable();
        this.cadastro.get('endereco_capacitadora.tipo_endereco').disable();
        this.cadastro.get('endereco_capacitadora.id_tipo_logradouro').disable();
        this.cadastro.get('endereco_capacitadora.logradouro').disable();
        this.cadastro.get('endereco_capacitadora.numero').disable();
        this.cadastro.get('endereco_capacitadora.complemento').disable();
        this.cadastro.get('endereco_capacitadora.bairro').disable();
        this.cadastro.get('endereco_capacitadora.id_uf').disable();
        this.cadastro.get('endereco_capacitadora.id_cidade').disable();
        this.cadastro.get('endereco_capacitadora.caixa_postal').disable();
        this.cadastro.get('endereco_capacitadora.flg_principal').disable();

        // Telefone
        this.cadastro.get('telefones.tipo_telefone').disable();
        this.cadastro.get('telefones.num_telefone').disable();

        // Email
        this.cadastro.get('emails.e_mail').disable();

        // Responsáveis
        this.cadastro.get('responsavel.cpf').disable();
        this.cadastro.get('responsavel.nome').disable();
        this.cadastro.get('responsavel.telefone').disable();
        this.cadastro.get('responsavel.email').disable();
        
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }
        this.uploadedFilesChange.emit(this.uploadedFiles);
        this.stepObject.emit(this);
        this.emitValidation(true);
    }

    removeElementList(value: any) {
        this.uploadedFiles.forEach((item, index) => {
            if (item.nome_arquivo === value.file.name && item.id < 1) {
                super.removeFromList(this.uploadedFiles, this.uploadedFilesChange, index, 'anexos');
            }
        });
    }
    adicionarResponsavel(event: any) {
        if (this.cadastro.get('responsavel').valid) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.cpf = this.limpaCaracterEspecial(this.cadastro.get('responsavel.cpf').value);
            this.service.Obter("capacitadora/pesquisarPorCPF", this.cpf).subscribe(retorno => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
                this.addToList(this.listaResponsaveis, this.listaResponsaveisChange, this.cadastro.get('responsavel') as FormGroup, event, { cpf: this.cadastro.get('responsavel.cpf').value }, { contador: retorno })
            });
        }
        else{
            this.touchAll(this.cadastro.get('responsavel') as FormGroup);
        }
    }

    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        } else {
            if (this.acao != 'alterar-responsavel') {
                let countListaArquivos = this.uploadedFiles.filter(item => item.tipo == 1).length;
                if (this.cadastro.get('capacitadora').valid && this.controladorFilial &&
                    this.listaResponsaveis.length > 0 && countListaArquivos > 0 && this.listaEmail.length > 0 &&
                    this.listaEndereco.length > 0 && this.listaTelefone.length > 0) {
                    this.isValid = true;
                } else {
                    this.isValid = false;
                    this.validateForm = [this.cadastro.get('capacitadora')];
                    if (!this.controladorFilial) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar a sede da capacitadora.');
                    }
                    else if (this.listaResponsaveis.length == 0) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar ao menos um responsável');
                    }
                    else if (countListaArquivos == 0) {
                        this.showMsg('warn', 'Mensagem de Aviso', `<p>O anexo de arquivos é obrigatório.<br><br> Todos os comprovantes deverão ser anexados de uma só vez.</p>`);
                    }
                    else if (this.listaEmail.length == 0) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar ao menos um Email');
                    }
                    else if (this.listaTelefone.length == 0) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar ao menos um Telefone');
                    }
                    else if (this.listaEndereco.length == 0) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar ao menos um Endereço');
                    }
                }
            }
            else if (this.acao == 'alterar-responsavel') {
                if (this.listaResponsaveis.length > 0) {
                    this.isValid = true;
                } else {
                    this.isValid = false;
                    if (this.listaResponsaveis.length == 0) {
                        this.showMsg('warn', 'Responsáveis', 'É necessário informar ao menos um responsável');
                    }
                }
            }
        }
        this.controladorFilialChange.emit(this.controladorFilial);
        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
        this.observableUtilPanelDoc.setBlockedPanel(false);
    }

    adicionarListaEndereco(event: any) {
        let filial = this.cadastro.get("endereco_capacitadora.flg_principal").value;
        if (filial == 1)
            this.cadastro.get("endereco_capacitadora.flg_principal").setValue(true);
        else
            this.cadastro.get("endereco_capacitadora.flg_principal").setValue(false);

        this.isValidCidade = false;
        let retorno = this.addToList(this.listaEndereco, this.listaEnderecoChange, this.cadastro.get('endereco_capacitadora') as FormGroup, event);

        if (retorno != false) {
            this.cadastro.get("endereco_capacitadora.flg_principal").patchValue("0");
            if (filial == 1) {
                this.controladorFilial = true;
                this.cadastro.get("endereco_capacitadora.flg_principal").setValue(true);
            }
            else {
                this.cadastro.get("endereco_capacitadora.flg_principal").setValue(false);
            }
        }
    }

    removeListaEndereco(index) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Deseja mesmo remover esse item da lista de endereço?`,
            accept: () => {
                var item = this.listaEndereco.splice(index, 1);
                this.listaEndereco = [...this.listaEndereco];
                this.listaEnderecoChange.emit(this.listaEndereco)
                if (this.listaEndereco.length == 0)
                    this.showMsgWarn(`É necessária a inclusão de ao menos 1 endereço.`);
                if (item[0].flg_principal == true) {
                    this.controladorFilial = false;
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/gerenciamento-capacitadora/crud/etapas/gerenciamento-capacitadora-etapa1.component.ts